module.exports = __webpack_public_path__ + "img/8_56.3ef05c48.png";